import { invert } from "lodash"

enum ColorTypes {
  RESOURCE_GROUP = 1,
  ARTICLE = 2,
}

export const ColorNames = invert(ColorTypes)

export default ColorTypes
